import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { inventoryManagementUrl, setupManagementUrl } from "../../../config";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { generateAndExecuteMutation, graphqlQuery } from "../../../data/Axios/DynamicService";

const base_url = inventoryManagementUrl.uri;

const BranchInventoryForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId, 10);


    const initialValues = {
      id: props.data ? props.data.id : "",
      averageBuyingPrice: props.data
        ? props.data.averageBuyingPrice || props.data.averageBP
        : 0,
      averageSellingPrice: props.data
        ? props.data.averageSellingPrice || props.data.averageSP
        : 0,
    };

   

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const {
        averageBuyingPrice,
        averageSellingPrice
      } = values;

      const parsedAverageBuyingPrice = parseFloat(averageBuyingPrice);
      const parsedAverageSellingPrice = parseFloat(averageSellingPrice);
      

      if (
        parsedAverageSellingPrice < parsedAverageBuyingPrice       
      ) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Average Selling Price cannot be less than the Average Buying Price.",
        });
        setSubmitting(false);
        return;
      }
      
      const mutationData = {
        averageBP: parseFloat(averageBuyingPrice),
        averageSP: parseFloat(averageSellingPrice)
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
      }

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateBranchInventory" : " ",
        mutationData,
        "branchInventory",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        // props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Inventory ${props.isEditing ? "updated" : "created"} successfully.`,
        });
          // Fix: Call refetchData unconditionally after successful operation
        props.onServerAction(); // This will trigger in the parent
    
      
      resetForm();
    }
    } catch (error) {
      console.error("Error submitting inventory item:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  const fields = [
    {
      name: "averageBuyingPrice",
      label: "Average Buying Price *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
     {
      name: "averageSellingPrice",
      label: "Average Selling Price *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  ];

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Inventory" : " "}
      subtitle={
        props.isEditing ? "Edit an existing Inventory Item" : " "
      }
    />
  );
};

export default BranchInventoryForm;
